import { formatDate } from "@fullcalendar/core";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Stack,
  Typography,
} from "@mui/material";
import { CustomAvatar } from "../../../../components/custom-avatar";
import { TableHeadCustom, TableNoData } from "../../../../components/table";
import { useAppContext } from "../../../../providers/AppContext";
import { useEffect, useState } from "react";

const TABLE_HEAD = [
  {
    id: "id",
    label: "ID",
    align: "left",
  },
  { id: "type", label: "Type", align: "center" },
  { id: "createdDate", label: "Created Date", align: "center" },
  { id: "reasonForVisit", label: "Reason For Visit", align: "right" },
];

type Props = {
  selectedRow: any;
  setPreviousRecordData: (data: any) => void;
  tab: string;
};
export const PreviousRecords = ({
  selectedRow,
  setPreviousRecordData,
  tab,
}: Props) => {
  const [selectedRowId, setSelectedRowId] = useState(null);

  const { clinicalRecords } = useAppContext();

  const filteredType = clinicalRecords.filter((records) => {
    return records.type === "Eye Examination";
  });

  const filteredRecords =
    tab !== "prescreening"
      ? filteredType.filter((records) => records.id !== selectedRow)
      : filteredType;

  const handleRowSelection = (item: any) => {
    setSelectedRowId(item.id);

    if (tab === "prescreening") {
      setPreviousRecordData(item?.prescreening || {});
    } else if (tab === "refraction") {
      setPreviousRecordData(item?.refraction || {});
    } else if (tab === "handover") {
      setPreviousRecordData(item?.handover || {});
    } else if (tab === "history_and_symptoms") {
      setPreviousRecordData(item?.patientSymptoms || {});
    } else if (tab === "examination") {
      setPreviousRecordData(item?.examination || {});
    }

  };

  return (
    <Table sx={{ minWidth: 800 }}>
      <TableHeadCustom headLabel={TABLE_HEAD} />
      <TableBody>
        {filteredRecords.map((item: any) => (
          <TableRow
            key={item.id}
            sx={{
              cursor: "pointer",
              backgroundColor:
                selectedRowId === item.id ? "#e0f7fa" : "inherit",
              "&:hover": {
                backgroundColor:
                  selectedRowId !== item.id ? "#f1f8e9" : "#e0f7fa",
              },
            }}
            onClick={() => {
              handleRowSelection(item);
            }}>
            <TableCell align="left">
              <Stack direction="row" alignItems="center" spacing={2}>
                <CustomAvatar name={`${item.id}`} />
                <div>
                  <Typography
                    variant="subtitle2"
                    noWrap
                    style={{ cursor: "pointer" }}></Typography>
                </div>
              </Stack>
            </TableCell>
            <TableCell align="center">{item.type}</TableCell>

            <TableCell align="center">{formatDate(item.createdDate)}</TableCell>
            <TableCell align="right">
              {item.prescreening?.reasonForVisit}
            </TableCell>
          </TableRow>
        ))}

        {/* <TableEmptyRows
        height={63}
        emptyRows={emptyRows(1, 1, clinicalRecords.length)}
      /> */}
        <TableNoData isNotFound={filteredRecords.length <= 0} />
      </TableBody>
    </Table>
  );
};
